/**
 * How many times the network interceptor retries a failed API request.
 * A 403 can be transient while authorization relationships are propagated.
 */
export function httpErrorRetryCount(options: {
  isServer: boolean;
  url: string;
  status: number;
  identifier?: string;
  code?: string;
  isBulkStatusZero?: boolean;
  isCaptureOne?: boolean;
  isInternalApi?: boolean;
}): number {
  if (options.isServer) return 0;
  if (options.isBulkStatusZero) return 0;
  if (options.isCaptureOne) return 0;
  if ([404, 422, 400, 503, 401, 409, 413, 402].includes(options.status)) return 0;
  if (options.code === 'password_required') return 0;
  if (options.identifier === 'access_denied' && options.url.includes('password=')) return 0;
  if (options.isInternalApi) return 0;
  if (options.status === 403) return 2;
  if (options.status === 0) return 3;
  return 1;
}
